import type { paths } from '@orlikfy/api-interfaces';

export type { CreateAppRatingDto } from '@orlikfy/api-interfaces';

// POST /rating/app
export const CREATE_RATING_PATH = '/rating/app' as const satisfies keyof paths;
type CreateRatingOperation = paths[typeof CREATE_RATING_PATH]['post'];
export type CreateRatingBody = CreateRatingOperation['requestBody']['content']['application/json'];
